module.exports = __webpack_public_path__ + "img/zorunlu-trafik-sigortasi.5e088896.svg";